/** @jsx jsx */
import PropTypes from 'prop-types'
import {jsx, css} from '@emotion/react'
import Stars from '../../../images/advertorial/stars.svg'

const Review = ({onClick}) => {
    const onKeyUp = (e) => {
        if (e.keyCode === 13) {
            onClick()
        }
    }
    return (
        <div
            css={css`
                background: #fafbfd;
                padding: 2rem;
                margin: 2rem 0;
                border-radius: 10px;
                &:hover {
                    cursor: pointer;
                }
            `}
            onClick={onClick}
            onKeyUp={onKeyUp}
            role="button"
            tabIndex={0}
        >
            <div>
                <Stars />
                <span
                    css={css`
                        margin-left: 1rem;
                    `}
                >
                    by Firefox user 15895900, 25 days ago
                </span>
            </div>
            <p
                css={css`
                    margin: 1rem 0 0 !important;
                    font-size: 1.5rem !important;
                    font-size: min(max(1.25rem, 3vw), 1.5rem) !important;
                    font-family: 'Proxima Nova SemiBold', sans-serif;
                    line-height: 1.25;
                `}
            >
                “I’ve used Startpage for several years and love it! No spam, no hacking… and no tracking. This is the
                best!”
            </p>
        </div>
    )
}

Review.propTypes = {
    onClick: PropTypes.func,
}

Review.defaultProps = {
    onClick: () => {},
}

export default Review
